import { getEmployeeDataGeneralSettings } from './queries/getEmployeeDataGeneralSettings';
import { listEmployeeFieldAccessRoles } from './queries/listEmployeeFieldAccessRoles';
import { listCustomFieldDefinitions } from './queries/listCustomFieldDefinitions';
import { getSavedCustomFieldView } from './queries/getSavedCustomFieldView';
import { listFieldsByUsage } from './queries/listFieldsByUsage';
import { queryEmployeeFields } from './queries/queryEmployeeFields';
import { updateEmployeeDataGeneralSettings } from './mutations/updateEmployeeDataGeneralSettings';
import { createCustomField } from './mutations/createCustomField';
import { updateCustomField } from './mutations/updateCustomField';
import { deleteCustomField } from './mutations/deleteCustomField';
import { updateSavedCustomFieldView } from './mutations/updateSavedCustomFieldView';

const queries = {
  getEmployeeDataGeneralSettings,
  listEmployeeFieldAccessRoles,
  listCustomFieldDefinitions,
  getSavedCustomFieldView,
  listFieldsByUsage,
  queryEmployeeFields,
};

const mutations = {
  updateEmployeeDataGeneralSettings,
  createCustomField,
  updateCustomField,
  deleteCustomField,
  updateSavedCustomFieldView,
};

export default {
  queries,
  mutations,
};
